import { Box, Typography } from "@outschool/backpack";
import { createPathWithActivity } from "@outschool/routes";
import { useLogSearchImpression } from "@outschool/ui-analytics";
import {
  IncrementalLoader,
  MiniListing as Listing
} from "@outschool/ui-components-website";
import { Link, Loading } from "@outschool/ui-legacy-component-library";
import { chunk, compact, flattenDeep, zip } from "lodash";
import React from "react";

export default function TabContent({
  title,
  listings = [],
  listingsLoading = false,
  carousels = [],
  showSaved = true
}: $TSFixMe) {
  if (!listings.length && !carousels.length) {
    return <Loading />;
  }

  // render 5 list cards in between carousels
  const listingsComponents = listings.map(
    (listing: $TSFixMe, index: $TSFixMe) => (
      <TabContentListing
        // @ts-ignore TS(2339): Property 'activity' does not exist on type 'never'... Remove this comment to see the full error message
        key={listing.activity.uid || index}
        listing={listing}
        listingIndex={index}
        showSaved={showSaved}
      />
    )
  );
  const chunkedListings = chunk(listingsComponents, 5);
  const components = compact(flattenDeep(zip(chunkedListings, carousels)));

  return (
    <Box
      flex
      sx={{
        flexDirection: "column",
        gap: "0.5em"
      }}
    >
      <Typography
        className="amp-block"
        data-private
        variant="h6"
        sx={{
          marginBottom: "1em",
          marginTop: "0.5em",
          fontWeight: 600
        }}
      >
        {title}
      </Typography>
      {listingsLoading ? <Loading /> : null}
      <IncrementalLoader rootMargin="200px 0px">{components}</IncrementalLoader>
    </Box>
  );
}

function TabContentListing({ listing, listingIndex, showSaved }: $TSFixMe) {
  const { trackSearchImpressionClick, searchImpressionRef } =
    useLogSearchImpression({
      listing,
      listingIndex,
      pageLocation: "PARENT_DASHBOARD"
    });
  return (
    <Link
      ref={searchImpressionRef}
      key={`listing_${listing.activity.uid}`}
      to={createPathWithActivity(listing.activity)}
      trackingName="parent dashboard card"
      trackingUniqueId={listing.activity.uid}
      sharedProperties={{
        insertion_id: listing.insertionId,
        cardLocation: "listing",
        activityUid: listing.activity.uid
      }}
      useLinkTracking
      trackViews={true}
      onClick={trackSearchImpressionClick}
    >
      <Listing listing={listing} showSaved={showSaved} />
    </Link>
  );
}
